// @ts-nocheck
import Alpine from 'alpinejs';
export * from 'alpinejs';
export default Alpine;
